import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { connect } from 'react-redux';
import Header from '../Header';
import Overlay from '../Overlay';
import { selectTheme } from '../../redux/ui/selectors';
import GlobalImageViewer from '../common/ImageViewer/GlobalImageViewer';

const MainLayout = ({ children, theme }) => (
  <div className={cn('MainLayout', { [theme]: theme })}>
    {children}
    <Overlay />
    <Header />
    <GlobalImageViewer />
  </div>
);

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
};

const mapStateToProps = state => ({
  theme: selectTheme(state),
});

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/components/MainLayout/index.jsx